// @generated by protobuf-ts 2.9.4
// @generated from protobuf file "mlmbox/client/google_authenticator/google_authenticator.proto" (package "mlmbox.client.google_authenticator", syntax proto3)
// tslint:disable
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { GoogleAuthenticator as GoogleAuthenticator$ } from "./google_authenticator.ts";
import type { GoogleAuthenticator_VerifiedCode_Response } from "../../types/google_authenticator.ts";
import type { GoogleAuthenticator_VerifiedCode_Request } from "../../types/google_authenticator.ts";
import type { GoogleAuthenticator_SecretCode } from "../../types/google_authenticator.ts";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { GoogleAuthenticator } from "../../types/google_authenticator.ts";
import type { Empty } from "../../../google/protobuf/empty.ts";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service mlmbox.client.google_authenticator.GoogleAuthenticator
 */
export interface IGoogleAuthenticatorClient {
    /**
     * @generated from protobuf rpc: Info(google.protobuf.Empty) returns (mlmbox.types.GoogleAuthenticator);
     */
    info(input: Empty, options?: RpcOptions): UnaryCall<Empty, GoogleAuthenticator>;
    /**
     * @generated from protobuf rpc: Generate(google.protobuf.Empty) returns (mlmbox.types.GoogleAuthenticator.SecretCode);
     */
    generate(input: Empty, options?: RpcOptions): UnaryCall<Empty, GoogleAuthenticator_SecretCode>;
    /**
     * @generated from protobuf rpc: Activate(mlmbox.types.GoogleAuthenticator.VerifiedCode.Request) returns (mlmbox.types.GoogleAuthenticator.VerifiedCode.Response);
     */
    activate(input: GoogleAuthenticator_VerifiedCode_Request, options?: RpcOptions): UnaryCall<GoogleAuthenticator_VerifiedCode_Request, GoogleAuthenticator_VerifiedCode_Response>;
    /**
     * @generated from protobuf rpc: Deactivate(mlmbox.types.GoogleAuthenticator.VerifiedCode.Request) returns (mlmbox.types.GoogleAuthenticator.VerifiedCode.Response);
     */
    deactivate(input: GoogleAuthenticator_VerifiedCode_Request, options?: RpcOptions): UnaryCall<GoogleAuthenticator_VerifiedCode_Request, GoogleAuthenticator_VerifiedCode_Response>;
}
/**
 * @generated from protobuf service mlmbox.client.google_authenticator.GoogleAuthenticator
 */
export class GoogleAuthenticatorClient implements IGoogleAuthenticatorClient, ServiceInfo {
    typeName = GoogleAuthenticator$.typeName;
    methods = GoogleAuthenticator$.methods;
    options = GoogleAuthenticator$.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: Info(google.protobuf.Empty) returns (mlmbox.types.GoogleAuthenticator);
     */
    info(input: Empty, options?: RpcOptions): UnaryCall<Empty, GoogleAuthenticator> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<Empty, GoogleAuthenticator>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Generate(google.protobuf.Empty) returns (mlmbox.types.GoogleAuthenticator.SecretCode);
     */
    generate(input: Empty, options?: RpcOptions): UnaryCall<Empty, GoogleAuthenticator_SecretCode> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<Empty, GoogleAuthenticator_SecretCode>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Activate(mlmbox.types.GoogleAuthenticator.VerifiedCode.Request) returns (mlmbox.types.GoogleAuthenticator.VerifiedCode.Response);
     */
    activate(input: GoogleAuthenticator_VerifiedCode_Request, options?: RpcOptions): UnaryCall<GoogleAuthenticator_VerifiedCode_Request, GoogleAuthenticator_VerifiedCode_Response> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<GoogleAuthenticator_VerifiedCode_Request, GoogleAuthenticator_VerifiedCode_Response>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: Deactivate(mlmbox.types.GoogleAuthenticator.VerifiedCode.Request) returns (mlmbox.types.GoogleAuthenticator.VerifiedCode.Response);
     */
    deactivate(input: GoogleAuthenticator_VerifiedCode_Request, options?: RpcOptions): UnaryCall<GoogleAuthenticator_VerifiedCode_Request, GoogleAuthenticator_VerifiedCode_Response> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<GoogleAuthenticator_VerifiedCode_Request, GoogleAuthenticator_VerifiedCode_Response>("unary", this._transport, method, opt, input);
    }
}
